module.exports = __webpack_public_path__ + "static/media/voice.fe1b272a.svg";